var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    desktop: _vm.$isElectron && _vm.isMac,
  },attrs:{"id":"app"}},[_c('router-view'),(!_vm.is_mobile)?_c('ExportTip'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }